module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Card', [_c('p', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(" Giro Jatuh Tempo ")]), _vm._v(" "), _c('Row', {
    attrs: {
      "type": "flex",
      "justify": "space-between"
    }
  }, [_c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Terima Giro")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "Select date"
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.giroDateSelected),
      callback: function($$v) {
        _vm.giroDateSelected = $$v
      },
      expression: "giroDateSelected"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('DatePicker', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "type": "daterange",
      "placeholder": "Select date"
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.paymentDateSelected),
      callback: function($$v) {
        _vm.paymentDateSelected = $$v
      },
      expression: "paymentDateSelected"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    staticStyle: {
      "display": "flex"
    },
    attrs: {
      "span": "5"
    }
  }, [_c('ButtonGroup', {
    staticClass: "custom-group-parent"
  }, [_c('Button', {
    staticClass: "custom-group"
  }, [_vm._v("Marking")]), _vm._v(" "), _c('Select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Select Marking",
      "remote-method": _vm.getMarkingByCode,
      "loading": _vm.isLoadingGetMarking
    },
    on: {
      "on-change": function($event) {
        return _vm.getReceivableGiroList()
      }
    },
    model: {
      value: (_vm.markingIdSelected),
      callback: function($$v) {
        _vm.markingIdSelected = $$v
      },
      expression: "markingIdSelected"
    }
  }, _vm._l((_vm.optionMarkings), function(option) {
    return _c('Option', {
      key: option.value,
      attrs: {
        "value": option.value
      }
    }, [_vm._v(_vm._s(option.label))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "6"
    }
  }, [_c('Spin', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoadingGiroList),
      expression: "isLoadingGiroList"
    }],
    attrs: {
      "size": "large"
    }
  })], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('Card', [_c('button', {
    staticClass: "ivu-btn ivu-btn-default ivu-btn-small",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateReport
    }
  }, [_c('span', [_vm._v("Generate PDF")])]), _vm._v(" "), _c('button', {
    staticClass: "ivu-btn ivu-btn-default ivu-btn-small",
    staticStyle: {
      "margin-right": "5px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateExcel
    }
  }, [_c('span', [_vm._v("Generate XLSX")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalGiro != 0),
      expression: "totalGiro != 0"
    }],
    attrs: {
      "type": "info",
      "show-icon": ""
    }
  }, [_vm._v(" Total Giro = " + _vm._s(_vm.totalGiro) + " lembar")]), _vm._v(" "), _c('Alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalGiro != 0),
      expression: "totalGiro != 0"
    }],
    attrs: {
      "type": "success",
      "show-icon": ""
    }
  }, [_vm._v(" Total Nominal = Rp " + _vm._s(_vm._f("numberFormatted")(_vm.totalNominal)))]), _vm._v(" "), _c('cHotGiroDueDate', {
    key: _vm.componentKey,
    attrs: {
      "hotHeaders": _vm.headerGiroDueDate,
      "hotColumns": _vm.columnGiroDueDate,
      "receivableGiroData": _vm.receivableGiroData
    },
    on: {
      "setHotGiroData": _vm.setHotGiroData
    }
  })], 1)], 1), _vm._v(" "), _c('vue-html2pdf', {
    ref: "html2Pdf",
    attrs: {
      "show-layout": false,
      "float-layout": true,
      "enable-download": true,
      "preview-modal": false,
      "paginate-elements-by-height": 1400,
      "filename": this.filename,
      "pdf-quality": 2,
      "manual-pagination": false,
      "pdf-format": "a4",
      "pdf-orientation": "landscape",
      "pdf-content-width": "100%"
    }
  }, [_c('section', {
    attrs: {
      "slot": "pdf-content"
    },
    slot: "pdf-content"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "table"
  }, [_c('div', {
    staticClass: "table-header"
  }, [_c('div', {
    staticClass: "header__item"
  }, [_vm._v("Marking")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Marking Group")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Tgl. Terima Giro")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Nomor Giro")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Nominal Giro")]), _vm._v(" "), _c('div', {
    staticClass: "header__item bank-header"
  }, [_vm._v("Bank")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Tgl. Jatuh Tempo")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Kliring")]), _vm._v(" "), _c('div', {
    staticClass: "header__item"
  }, [_vm._v("Dibatalkan")])]), _vm._v(" "), _c('div', {
    staticClass: "table-content"
  }, _vm._l((_vm.hotGiroData), function(value) {
    return _c('div', {
      staticClass: "table-row"
    }, [_c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.marking))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.markingGroup))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.giroDate))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.paymentDate))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.giroNumber))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.giroNominal))]), _vm._v(" "), _c('div', {
      staticClass: "table-data bank-body"
    }, [_vm._v(_vm._s(value.accountName))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.dueDate))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.isClearing))]), _vm._v(" "), _c('div', {
      staticClass: "table-data"
    }, [_vm._v(_vm._s(value.isCancel))])])
  }), 0)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b544c18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/giro/GiroDueDate.vue
// module id = 1776
// module chunks = 1